module.exports = __webpack_public_path__ + "img/caret-right.3ffd3de2.svg";